import { match } from 'ts-pattern'

export const getTaxErrorReason = (errorType: string): string =>
  match(errorType)
    .with('MISSING_TAX_CODE_MAPPING', () => 'a missing tax code mapping error')
    .with('MISSING_TAX_CATEGORY', () => 'a missing tax category error')
    .with('CREDENTIALS_ERROR', () => 'a credentials error')
    .with('CREDENTIALS_NOT_FOUND', () => 'a credentials not found error')
    .with('VALIDATION_ERROR', () => 'a validation error')
    .with('PROVIDER_NOT_FOUND', () => 'a provider not found error')
    .with('RATE_LIMIT', () => 'a rate limit error')
    .with('PROVIDER_API_ERROR', () => 'a provider API error')
    .with('PROVIDER_SERVER_ERROR', () => 'a provider server error')
    .otherwise(() => 'an error')

export const formatProviderName = (taxProvider: string): string =>
  match(taxProvider.toUpperCase())
    .with('AVALARA', () => 'Avalara')
    .with('NUMERAL', () => 'Numeral')
    .with('SPHERE', () => 'Sphere')
    .with('ANROK', () => 'Anrok')
    .otherwise(() => taxProvider)

/**
 * What the operator has to do to unblock the invoice, for the error types they can fix themselves.
 * Undefined for provider outages and rate limits, which resolve without anyone acting.
 */
export const getTaxErrorResolution = (
  errorType: string,
  taxProvider: string,
  taxCategoryName?: string | null
): string | undefined => {
  const providerName = formatProviderName(taxProvider)

  return match(errorType)
    .with('MISSING_TAX_CODE_MAPPING', () =>
      taxCategoryName
        ? `The tax category "${taxCategoryName}" is not mapped to a tax category in ${providerName}. Map it in your ${providerName} settings, then re-issue the invoice.`
        : `One or more tax categories are not mapped to tax categories in ${providerName}. Map them in your ${providerName} settings, then re-issue the invoice.`
    )
    .with(
      'MISSING_TAX_CATEGORY',
      () =>
        'One or more line items have no tax category. Set a tax category on them, then re-issue the invoice.'
    )
    .with(
      'CREDENTIALS_ERROR',
      'CREDENTIALS_NOT_FOUND',
      () =>
        `Check the ${providerName} credentials in your integration settings, then re-issue the invoice.`
    )
    .otherwise(() => undefined)
}
